import styled from 'styled-components';
import { breakpoint, font } from 'styles/globals';
import { getColor, Theme } from 'styles/theme';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 48px;

  @media (${breakpoint.lgMin}) {
    gap: 68px;
  }

  .simple-homepage {
    margin-top: 0;
  }
`;

export const CategorySection = styled.div`
  display: flex;
  flex-direction: column;
`;

export const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  text-transform: capitalize;

  .category-title {
    font-family: ${font.saolText};
  }
`;

export const MoreLink = styled.div<{ theme: Theme; mobileOnly?: boolean }>`
  margin-top: 24px;
  text-align: right;
  
  @media (${breakpoint.mdMin}) {
    margin-top: 0;
    text-align: left;
  }

  display: ${(props) => (props.mobileOnly ? 'block' : 'none')};
  @media (${breakpoint.mdMin}) {
    display: ${(props) => (props.mobileOnly ? 'none' : 'inline-flex')};
  }

  .more-link {
    color: ${getColor('textSecondary')};
    &::after {
      border-color: ${getColor('textSecondary')};
    }
  }
`;

export const CategoryChildWrapper = styled.div`

  @media (${breakpoint.lgMin}) {
    display: flex;
    gap: 40px;
  }
`;

export const FeatureArticle = styled.div<{ $isLeft: boolean }>`
  flex: 1;
  order: ${({ $isLeft }) => ($isLeft ? 1 : 2)};
  margin-bottom: 40px;

  @media (${breakpoint.lgMin}) {
    margin-bottom: 0;
  }
`;

export const ArticleList = styled.div<{ $isLeft: boolean; theme: Theme }>`
  flex: 1;
  order: ${({ $isLeft }) => ($isLeft ? 2 : 1)};
  display: flex;
  flex-direction: column;
  gap: 24px;

  .nativo-section-2,
  .nativo-section-3,
  .nativo-section-4,
  .nativo-section-5,
  .nativo-section-6
    {
    min-height: 125px;
    padding-bottom: 24px;
    border-bottom: 1px solid ${getColor('borderSecondary')};
  }

  .nativo-tout--term-archive-1__card {
    padding-bottom: 24px;
    border-bottom: 1px solid ${getColor('borderSecondary')};
  }

  .nativo-tout--term-archive-1__image {
    display: none;
  }

  .ntvAdChoicesLink {
    display: none;
  }

  .ntv-headline {
    font-size: 20px;
    line-height: 120%; 
    letter-spacing: 0.4px;
  }
`;
